import { useDropdownContext } from '../../Dropdown';

/**
 * The no-results message `Dropdown` renders below its items when none are left, using its `noDataText`.
 * Pass `noDataText={null}` to the Dropdown to suppress it.
 */
export function DropdownEmptyState({ text = 'No results found' }: { text?: string }) {
  const { items } = useDropdownContext();

  if (items.length) {
    return null;
  }

  return <div className="label-100 p-4 text-center text-neutral-600">{text}</div>;
}
